import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';
import React from 'react';

export default function EditIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      htmlColor="transparent"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1081 13.432H14.3594"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="none"
        d="M9.54507 3.4704C10.0364 2.8444 10.8304 2.87707 11.4571 3.3684L12.3837 4.09507C13.0104 4.5864 13.2324 5.3484 12.7411 5.97574L7.21507 13.0257C7.0304 13.2617 6.7484 13.4011 6.4484 13.4044L4.31707 13.4317L3.8344 11.3551C3.7664 11.0637 3.8344 10.7571 4.01907 10.5204L9.54507 3.4704Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5101 4.79077L11.7061 7.2961"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
